/**
 * @class
 * @extends mkE.Base
 */
T.ListEvent = Class(
	/**
	 * @lends {T.ListEvent#}
	 */
	{
		TYPE_STANDARD: null,
		TYPE_HOME: 'home',

		/** @type {DR.events.struct.Event} */
		event: null,

		/**
		 * @param {DR.events.struct.Event} event
		 * @private
		 */
		__construct: function(event) {
			this.event = event;
			this.node = mkE({
				tag: 'div',
				className: 't_list_event'
			});
			if (this.event) {
				this._draw();
			} else {
				this._drawPlaceholder();
			}
		},
		_drawPlaceholder() {
			addClassName(this.node, 'event--placeholder');
			mkE({
				tag: 'div',
				className: 'placeholder-wave',
				els: [
					{
						tag: 'div',
						className: 'event__cover'
					},
					{
						tag: 'div',
						className: 'h4'
					}
				]
			}).append(this.node);
		},
		_draw() {
			const event = this.event;
			let classNames = [];
			if (event.hasEnded) {
				classNames.push('event--past');
			}
			const isFuture = event.startTime > D.TIME;
			if (isFuture) {
				classNames.push('event--future');
			}
			addClassName(this.node, classNames.join('\s'));
			mkE({
				tag: 'a',
				href: D.url('/event/' + event.seoTitle),
				els: [
					{
						tag: 'div',
						className: 'event__cover',
						els: [
							event.hasImage ? {
								tag: 'img',
								src: event.image.medium,
								loading: 'lazy',
								alt: event.title
							} : '',
							{
								tag: 'div',
								els:[
									this._getBadgeTransportType(),
									this._getBadgePins(),
									{
										tag: 'div',
										className: 'event__badge w-100',
										els: [
											this._getTime(),
											this._getDistance()
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'h4',
						text: event.title
					},
					this._getRating()
				]
			}).append(this.node);
		},
		_getBadgePins() {
			const event = this.event;
			if (event.stats.pins <= 0) {
				return '';
			}
			return {
				tag: 'div',
				className: 'event__badge w-svg-icon',
				title: D.Lang.get('events.item.pins'),
				els: [
					D.svgIcon('pins'),
					{tag: 'span', text: event.stats.pins}
				]
			};
		},
		_getBadgeTransportType() {
			const event = this.event;
			if (event.settings.transportType === 'virtual') {
				return '';
			}
			return {
				tag: 'div',
				className: 'event__badge',
				title: D.Lang.get('events.filter.transportType.' + event.settings.transportType),
				els: [
					D.svgIcon('transport-type-' + event.settings.transportType)
				]
			};
		},
		_getTime() {
			const event = this.event;
			let hours = Math.ceil((event.endTime - event.startTime) / 3600);
			let ext = "h";
			if (event.settings.gameType === 'anytime') {
				hours = Math.ceil(event.settings.gameTime / 60);
				if (event.settings.hasTimeExtension) {
					ext += "+";
				}
			}
			return {
				tag: 'span',
				className: 'w-svg-icon',
				title: D.Lang.get('events.item.time'),
				els: [
					D.svgIcon('time'),
					{tag: 'span', text: hours + ext}
				]
			};
		},
		_getDistance() {
			const event = this.event;
			if (event.stats.distance <= 0) {
				return '';
			}
			return {
				tag: 'span',
				className: 'w-svg-icon',
				title: D.Lang.get('events.item.distance'),
				els: [
					D.svgIcon('distance'),
					{tag: 'span', text: Math.round(event.stats.distance / 1000) + 'km'}
				]
			};
		},
		_getRating() {
			const event = this.event;
			if (event.isNewGame) {
				let usersPlayed = '';
				if (event.settings.gameType === 'race' && event.stats.players >= 10) {
					usersPlayed = ' · ' + D.Lang.nget(event.stats.players, 'event.users_played');
				}
				return {
					tag: 'div',
					className: 'event__rating',
					els: [
						D.svgIcon({
							icon: 'star',
							color: 'dark-turquoise'
						}),
						{
							tag: 'b',
							text: D.Lang.get('events.new_event')
						},
						usersPlayed
					]
				};
			} else if (event.userRating !== null && event.userRating.rating > 0) {
				return {
					tag: 'div',
					className: 'event__rating',
					els: [
						D.svgIcon({
							icon: 'star',
							color: 'pink'
						}),
						{
							tag: 'b',
							text: event.userRating.rating.toFixed(2) + ' '
						},
						' (' + event.userRating.users + ') · ' + D.Lang.nget(event.stats.players, 'event.users_played')
					]
				};
			} else {
				return '';
			}
		},
		_getEventDate() {
			const event = this.event;
			if (event.settings.hasUnknownDate) {
				return D.Lang.get('event.welcome.soon');
			}
			if (event.settings.gameType === 'race') {
				let startDate = new D.Date(event.startTime);
				let endDate = new D.Date(event.endTime);
				let endFormat = '%H:%i';
				if (startDate.getMonth() !== endDate.getMonth() || startDate.getDate() !== endDate.getDate()) {
					endFormat = D.Lang.get('events.list.dateFormat') + ', %H:%i';
				}
				return startDate.format2(D.Lang.get('events.list.dateFormat') + ', %H:%i').toUpperCase() + '-' +
					endDate.format2(endFormat).toUpperCase();
			}
			return '';
		}
	},
	mkE.Base
);
